// All popup types the app has
export const POPUP_TYPE = {
  ADD_PRODUCT_POPUP: "AddProductPopup",
  PRODUCT_DETAIL_POPUP: "ProductDetailPopup",
  REMOVE_PRODUCT_POPUP: "RemoveProductPopup",
  SOCIAL_LINKS_POPUP: "SocialLinksPopup",
  CHOOSE_BANNER_POPUP: "ChooseBannerPopup",
  TOUR_START_POPUP: "TourStartPopup",
  GET_ACCESS_POPUP: "GetAccessPopup",
  SHARE_YOUR_STORE_POPUP: "ShareYourStore",
  YES_NO_ALERT_POPUP: "YesNoAlert",
  DISCRIPTION_POPUP: "DiscriptionPopup",
};
// All pAGES types the app has
export const MAIN_COMPONENTS_STATE = {
  DASHBOARD: "Dashboard",
};
